import { z } from 'zod';

export const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

export const passwordSchema = z
  .string()
  .min(12, 'At least 12 characters')
  .regex(/[a-z]/, 'Lowercase letter')
  .regex(/[A-Z]/, 'Uppercase letter')
  .regex(/[0-9]/, 'Number')
  .regex(SPECIAL_CHAR_REGEX, 'Special character');

export const passwordRequirements = [
  { label: 'At least 12 characters', check: (p: string) => p.length >= 12 },
  { label: 'Uppercase letter', check: (p: string) => /[A-Z]/.test(p) },
  { label: 'Lowercase letter', check: (p: string) => /[a-z]/.test(p) },
  { label: 'Number', check: (p: string) => /[0-9]/.test(p) },
  { label: 'Special character', check: (p: string) => SPECIAL_CHAR_REGEX.test(p) },
] as const;

export interface LinkStatusDto {
  isLinked: boolean;
  isEligible: boolean;
}
